import React, { useState, useEffect, useCallback } from "react";
import {
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  Button,
  CardBody,
  CardHeader,
} from "reactstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { showSweetAlert } from "../../Common/SweetAlert";
import {
  addEducationRequest,
  deleteEducationBackgroundRequest,
  resetData,
} from "../../../redux/jobseeker/add_education/actions";
import { fetchJobseekerDataRequest } from "../../../redux/jobseeker/fetch_Jobseeker_data/actions";
import { showToast } from "../../Common/Toast";
import { FiPlusSquare } from "react-icons/fi";
import { fetchEducationRequest } from "../../../redux/education/actions";
import {
  educationLevelsOptions,
  educationBoardsOptions,
  schoolMediumsOptions,
  customOptionsStyle,
  passingyearsOptions,
  performanceScaleOptions,
  courseTypeOptions,
} from "../../../Constant";
import AddEducationCard from "./AddEducationCard";
import { handleNumberInput } from "../../Common/CommonFunction";
import { generatePassingYearsOptions } from "../../../Constant";

const EducationBackground = ({ profileData, validationMessages }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState(
    profileData?.education?.map((edu) => ({
      id: edu.id || "",
      education_level:
        educationLevelsOptions.find(
          (option) => option.value === edu.education_level
        ) || null,
      board:
        educationBoardsOptions.find((option) => option.value === edu.board) ||
        null,
      school_medium:
        schoolMediumsOptions.find(
          (option) => option.value === edu.school_medium
        ) || null,
      jobseeker_college_name: edu.jobseeker_college_name || "",
      jobseeker_degree: edu.jobseeker_degree || null,
      jobseeker_education_type:
        courseTypeOptions.find(
          (option) => option.value === edu.jobseeker_education_type
        ) || null,
      jobseeker_specialization: edu.jobseeker_specialization || "",
      passing_year:
        passingyearsOptions.find(
          (option) => option.value === edu.passing_year
        ) || null,
      performance_scale:
        performanceScaleOptions.find(
          (option) => option.value == edu.performance_scale
        ) || null,
      performance: edu.performance || "",
      isSchool:
        edu.education_level === "SECONDARY" ||
        edu.education_level === "SENIOR_SECONDARY",
      type: edu.type || "",
    })) || [
      {
        id: "",
        education_level: null,
        board: null,
        school_medium: null,
        jobseeker_college_name: "",
        jobseeker_degree: null,
        jobseeker_education_type: null,
        jobseeker_specialization: "",
        passing_year: null,
        performance_scale: null,
        performance: "",
        isSchool: false,
        type: "",
      },
    ]
  );

  const [errors, setErrors] = useState([]);

  const [showNewEntryForm, setShowNewEntryForm] = useState(false);

  const [educationOptions, setEducationOptions] = useState([]);
  let educationReducerData = useSelector((state) => state.educationReducer);
  let educationData = educationReducerData.data.data;

  const [existingEducationLevelOptions, setExistingEducationLevelOptions] =
    useState(null);
  useEffect(() => {
    const matchedOptions = educationLevelsOptions.filter(
      (option) =>
        profileData.education &&
        profileData.education.some(
          (education) =>
            education.education_level === option.value &&
            (education.education_level == "SECONDARY" ||
              education.education_level == "SENIOR_SECONDARY")
        )
    );
    // console.log("mat",matchedOptions);
    setExistingEducationLevelOptions(matchedOptions);
  }, []);

  useEffect(() => {
    educationData = educationData || [];
    setEducationOptions(educationData);
  }, [educationData]);



  const handleChange = (e, index) => {
    const { name, value } = e.target;
    const updatedFormData = [...formData];
    updatedFormData[index][name] = value;
    setFormData(updatedFormData);
    setErrors((prev) => {
      const updatedErrors = [...prev];
      if (!updatedErrors[index]) updatedErrors[index] = {};
      updatedErrors[index][name] = ""; // Clear the specific error
      return updatedErrors;
    });
  };

  const handleFieldChange = (field, value, index) => {
    const updatedFormData = [...formData];
    updatedFormData[index][field] = value;

    if (field === "education_level") {
      const isSchoolLevel =
        value.value === "SECONDARY" || value.value === "SENIOR_SECONDARY";
      updatedFormData[index].isSchool = isSchoolLevel;
    }

    setFormData(updatedFormData);
    setErrors((prev) => {
      const updatedErrors = [...prev];
      if (!updatedErrors[index]) updatedErrors[index] = {};
      updatedErrors[index][field] = ""; // Clear the specific error
      return updatedErrors;
    });
  };

  const validateForm = (index) => {
    const entry = formData[index];
    const entryErrors = {};

    // Validate education level
    if (!entry.education_level) {
      entryErrors.education_level = "Education Level is required.";
    }

    // Validate school-specific fields
    if (entry.isSchool) {
      if (!entry.board) {
        entryErrors.board = "Board is required for school level.";
      }
      if (!entry.school_medium) {
        entryErrors.school_medium = "School Medium is required for school level.";
      }
    } else {
      // Validate college-specific fields
      if (!entry.jobseeker_college_name) {
        entryErrors.jobseeker_college_name = "College Name is required.";
      }
      if (!entry.jobseeker_degree) {
        entryErrors.jobseeker_degree = "Degree is required.";
      }
      if (!entry.jobseeker_education_type) {
        entryErrors.jobseeker_education_type = "Course Type is required.";
      }
    }

    // Validate passing year
    if (!entry.passing_year) {
      entryErrors.passing_year = "Passing Year is required.";
    } else {
      //console.log("dob", props.dob, "passing", formData.passing_year);

      const dobYear = new Date(profileData.jobseeker_date_of_birth).getFullYear();
      const passingYear = parseInt(entry.passing_year.value, 10);

      console.log("passingYear", passingYear, "dobYear", dobYear);

      if (passingYear < dobYear) {
        entryErrors.passing_year = "Passing year cannot be before Date of Birth";

      }
    }

    // Validate performance input if provided
    if (entry.performance) {
      const numericValue = parseFloat(entry.performance);

      // Check for invalid decimal input (e.g., "2.")
      if (entry.performance.endsWith('.')) {
        entryErrors.performance = "Performance cannot end with a decimal point.";
      } else if (isNaN(numericValue)) {
        entryErrors.performance = "Performance must be a valid number.";
      } else {
        // Validate based on performance scale
        if (entry.performance_scale?.label === "CGPA (Scale of 10)") {
          if (numericValue <= 2 || numericValue > 10) {
            entryErrors.performance = "CGPA must be greater than 2 and between 3 and 10.";
          }
        } else if (entry.performance_scale?.label === "Percentage") {
          if (numericValue < 35 || numericValue > 100) {
            entryErrors.performance = "Percentage must be between 35 and 100.";
          }
        } else if (entry.performance_scale?.label === "CGPA (Scale of 4)") {
          if (numericValue < 1.6 || numericValue > 4) {
            entryErrors.performance = "CGPA must be between 1.6 and 4.";
          }
        } else if (entry.performance_scale?.label === "CGPA (Scale of 7)") {
          if (numericValue < 2.0 || numericValue > 7.0) {
            entryErrors.performance = "CGPA must be between 2.0 and 7.0.";
          }
        } else if (entry.performance_scale?.label === "CGPA (Scale of 5)") {
          if (numericValue < 2.0 || numericValue > 5.0) {
            entryErrors.performance = "CGPA must be between 2.0 and 5.0.";
          }
        }
      }
    }

    return entryErrors; // Return errors specific to this entry
  };

  const handleSubmit = (index) => {
    const validationErrors = validateForm(index);
    if (Object.keys(validationErrors).length > 0) {
      const updatedErrors = [...errors];
      updatedErrors[index] = validationErrors; // Set errors for the specific entry
      setErrors(updatedErrors);
      return;
    }

    const entry = formData[index];
    const formattedData = {
      id: entry.id || "",
      education_level: entry.education_level.value || "",
      board: entry.board ? entry.board.value : null,
      school_medium: entry.school_medium ? entry.school_medium.value : null,
      jobseeker_college_name: entry.jobseeker_college_name || "",
      jobseeker_degree: entry.jobseeker_degree
        ? entry.jobseeker_degree.value
        : null,
      jobseeker_education_type: entry.jobseeker_education_type
        ? entry.jobseeker_education_type.value
        : null,
      jobseeker_specialization: entry.jobseeker_specialization || "",
      passing_year: entry.passing_year ? entry.passing_year.value : null,
      performance_scale: entry.performance_scale
        ? entry.performance_scale.value
        : null,
      performance: entry.performance || "",
    };

    dispatch(addEducationRequest(formattedData));
  };

  const handleEducationBackgroundDeleteClick = (job_id) => {
    console.log("ji", job_id);
    showSweetAlert("confirm", {
      message: "You want to delete the eduction",
      fun: handleEducationBackground,
      id: job_id,
    });
  };

  const handleEducationBackground = (education) => {
    console.log("deleteEducationBackgroundRequest", education);
    // Dispatch the delete action when delete button is clicked
    dispatch(
      deleteEducationBackgroundRequest({
        id: education.id,
        type: education.type,
      })
    );
  };

  const handleEducationChange = (selectedOption, index) => {
    const updatedFormData = [...formData];
    updatedFormData[index].jobseeker_education = selectedOption;
    setFormData(updatedFormData);
  };

  const handleEducationTypeChange = (selectedOption, index) => {
    const updatedFormData = [...formData];
    updatedFormData[index].jobseeker_education_type = selectedOption;
    setFormData(updatedFormData);
  };

  const addEducationReducerData = useSelector(
    (state) => state.addEducationReducer
  );
  useEffect(() => {
    console.log("srd", addEducationReducerData);
    if (
      addEducationReducerData.status &&
      addEducationReducerData.message != ""
    ) {
      showToast("success", addEducationReducerData.message);

      dispatch(resetData());
      dispatch(fetchJobseekerDataRequest());
    } else if (
      addEducationReducerData.status == false &&
      addEducationReducerData.message != ""
    ) {
      showToast("error", addEducationReducerData.message);

      dispatch(resetData());
      dispatch(fetchJobseekerDataRequest());
    }
  }, [dispatch, addEducationReducerData]);

  const handleEducationFocus = (educationLevel) => {

    // This function will be called when the location dropdown is focused
    // You can trigger your API call here
    const fetchData = async () => {
      try {
        const keyword = ""; // Set your keyword value here
        dispatch(fetchEducationRequest(keyword, educationLevel));
      } catch (error) {
        console.error(error);
      }
    };

    // Call the fetchData function when the location dropdown is focused
    fetchData();
  };

  // Callback to handle location input change
  const handleEducationInputChange = useCallback((inputValue, educationLevel) => {

    // Fetch data based on the inputValue (keyword)
    const fetchData = async () => {
      try {
        console.log("handleEducationInputChange");
        dispatch(fetchEducationRequest(inputValue, educationLevel));
      } catch (error) {
        // Handle any errors if necessary
      }
    };

    // Call the fetchData function when the location input changes
    fetchData();
  }, []);

  const [showValidationMessages, setValidationMessages] = useState();
  useEffect(() => {
    // Check if validationMessages is an object with the errors
    if (validationMessages && typeof validationMessages === "object") {
      setValidationMessages(validationMessages);
      console.log("validationMessages888", validationMessages);
    }
  }, [validationMessages]);

  return (
    <Form>
      <CardHeader className="d-flex align-items-center justify-content-between">
        <h4>Education Background</h4>
        <FiPlusSquare
          className="add-icon"
          size={22}
          onClick={() => setShowNewEntryForm(true)} // Show new entry form
          title="Add"
        />
      </CardHeader>

      <CardBody>
        {showValidationMessages && (
          <div className="text-danger mb-4">
            {showValidationMessages.education_details}
          </div>
        )}
        {showNewEntryForm && (
          <AddEducationCard dob={profileData.jobseeker_date_of_birth} data={existingEducationLevelOptions} />
        )}
        {formData.map((education, index) => (
          <div key={index} className="mb-4">
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>
                    Education Level <span className="text-danger">*</span>
                  </Label>
                  <Select
                    options={educationLevelsOptions}
                    value={education.education_level}
                    onChange={(selectedOption) =>
                      handleFieldChange(
                        "education_level",
                        selectedOption,
                        index
                      )
                    }
                    isDisabled
                  />
                  {errors[index]?.education_level && (
                    <div className="text-danger">
                      {errors[index].education_level}
                    </div>
                  )}
                </FormGroup>
              </Col>
              {education.isSchool && (
                <>
                  <Col md={6}>
                    <FormGroup>
                      <Label>
                        Board <span className="text-danger">*</span>
                      </Label>
                      <Select
                        options={educationBoardsOptions}
                        value={education.board}
                        onChange={(selectedOption) =>
                          handleFieldChange("board", selectedOption, index)
                        }
                      />
                      {errors[index]?.board && (
                        <div className="text-danger">{errors[index].board}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label>
                        School Medium <span className="text-danger">*</span>
                      </Label>
                      <Select
                        options={schoolMediumsOptions}
                        value={education.school_medium}
                        onChange={(selectedOption) =>
                          handleFieldChange(
                            "school_medium",
                            selectedOption,
                            index
                          )
                        }
                      />
                      {errors[index]?.school_medium && (
                        <div className="text-danger">
                          {errors[index].school_medium}
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                </>
              )}
              {!education.isSchool && (
                <>
                  <Col md={6}>
                    <FormGroup>
                      <Label>
                        College Name <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        name="jobseeker_college_name"
                        placeholder="Enter college name"
                        value={education.jobseeker_college_name}
                        onChange={(e) => handleChange(e, index)}
                        maxLength={100}
                      />
                      {errors[index]?.jobseeker_college_name && (
                        <div className="text-danger">
                          {errors[index].jobseeker_college_name}
                        </div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col
                    md={6}
                    className={
                      formData[index].current_company !== "YES" ? "" : "d-none"
                    }
                  >
                    <FormGroup>
                      <Label>
                        Course
                        <span className="text-danger">*</span>
                      </Label>
                      <Select
                        options={educationOptions}
                        isLoading={educationReducerData.isLoading}
                        placeholder="Select course"
                        value={formData[index].jobseeker_degree}
                        onChange={(selectedOption) =>
                          handleEducationChange(selectedOption, index)
                        }
                        styles={customOptionsStyle}
                        onInputChange={(inputValue) => handleEducationInputChange(inputValue, formData[index].education_level.value)} // Pass the education level
                        onFocus={() => handleEducationFocus(formData[index].education_level.value)}
                      />
                      {errors[index]?.jobseeker_degree && (
                        <small className="text-danger">
                          {errors[index].jobseeker_degree}
                        </small>
                      )}
                    </FormGroup>
                  </Col>

                  <Col
                    md={6}
                    className={
                      formData[index].current_company !== "YES" ? "" : "d-none"
                    }
                  >
                    <FormGroup>
                      <Label for="jobseeker_education_type">
                        Course Type
                        <span className="text-danger">*</span>
                      </Label>
                      <Select
                        options={courseTypeOptions}
                        placeholder="Select course type"
                        value={formData[index].jobseeker_education_type}
                        onChange={(selectedOption) =>
                          handleEducationTypeChange(selectedOption, index)
                        }
                      />
                      {errors[index]?.jobseeker_education_type && (
                        <small className="text-danger">
                          {errors[index].jobseeker_education_type}
                        </small>
                      )}
                    </FormGroup>
                  </Col>
                  <Col
                    md={6}
                    className={
                      formData[index].current_company !== "YES" ? "" : "d-none"
                    }
                  >
                    <FormGroup>
                      <Label>
                        Specialization
                        {/* <span className="text-danger">*</span> */}
                      </Label>
                      <Input
                        className="form-control form-control-sm"
                        type="text"
                        name="jobseeker_specialization"
                        placeholder="Enter specialization"
                        value={formData[index].jobseeker_specialization}
                        onChange={(e) => handleChange(e, index)}
                        maxLength={50}
                      />
                      {/* {errors[index]?.jobseeker_specialization && (
                    <small className="text-danger">{errors[index].jobseeker_specialization}</small>
                  )} */}
                    </FormGroup>
                  </Col>
                </>
              )}
              <Col md={6}>
                <FormGroup>
                  <Label>
                    Passing Year <span className="text-danger">*</span>
                  </Label>
                  <Select
                    options={generatePassingYearsOptions(false)}
                    value={education.passing_year}
                    onChange={(selectedOption) =>
                      handleFieldChange("passing_year", selectedOption, index)
                    }
                  />
                  {errors[index]?.passing_year && (
                    <div className="text-danger">
                      {errors[index].passing_year}
                    </div>
                  )}
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>
                    Score
                  </Label>
                  <Select
                    options={performanceScaleOptions}
                    value={education.performance_scale}
                    onChange={(selectedOption) =>
                      handleFieldChange(
                        "performance_scale",
                        selectedOption,
                        index
                      )
                    }
                  />
                  {errors[index]?.performance_scale && (
                    <div className="text-danger">
                      {errors[index].performance_scale}
                    </div>
                  )}
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>
                    Performance
                  </Label>
                  <Input
                    type="text"
                    name="performance"
                    placeholder="Enter performance"
                    value={education.performance}
                    // onChange={(e) => handleChange(e, index)}
                    onInput={(e) => {
                      const max = formData[index].performance_scale?.label === "Percentage" ? 100 :
                        formData[index].performance_scale?.label === "CGPA (Scale of 10)" ? 10 :
                          formData[index].performance_scale?.label === "CGPA (Scale of 7)" ? 7 :
                            formData[index].performance_scale?.label === "CGPA (Scale of 5)" ? 5 :
                              formData[index].performance_scale?.label === "CGPA (Scale of 4)" ? 4 :
                                undefined; // Default case if none match

                      const value = e.target.value;

                      // Allow integer and decimal values for Percentage scale
                      if (formData.performance_scale?.label === "Percentage") {
                        if (value && !/^\d*(\.\d{0,2})?$/.test(value)) {
                          e.preventDefault(); // Prevent invalid input
                          return;
                        }
                      } else if (formData.performance_scale?.label.startsWith("CGPA")) {
                        // Allow up to 2 decimal places for CGPA
                        if (value && !/^\d*(\.\d{0,2})?$/.test(value)) {
                          e.preventDefault(); // Prevent invalid CGPA input
                          return;
                        }
                      }

                      // Call handleNumberInput with the correct parameters
                      handleNumberInput(e, (event) => handleChange(event, index), 0, max, true);
                    }}
                    min={0}

                  />
                  {errors[index]?.performance && (
                    <div className="text-danger">
                      {errors[index].performance}
                    </div>
                  )}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col className="d-flex justify-content-end">
                <Button
                  className="me-2"
                  color="primary"
                  onClick={() => handleSubmit(index)}
                >
                  Update
                </Button>
                <Button
                  color="danger"
                  onClick={() =>
                    handleEducationBackgroundDeleteClick(education)
                  }
                >
                  Delete
                </Button>
              </Col>
            </Row>
          </div>
        ))}
      </CardBody>
    </Form>
  );
};

export default EducationBackground;
